import { useState, useEffect, useCallback } from "react";
import mqtt from "mqtt";
import * as Const from "./../_Const";

/**
 * Custom React Hook pro připojení k MQTT brokeru
 * a sledování zpráv na definovaném tématu.
 * * @param {string} url - URL WebSocketu Mosquitto (např. 'ws://192.168.0.228:9001')
 * @param {string} topic - Téma, ke kterému se připojit
 * @param {function(message: Object)} onNewMessageCallback - Funkce volaná při každé nové zprávě.
 * @returns {{isConnected: boolean, messages: Array, publish: function(topic: string, message: string)}}
 */
const useMqttClient = (url, topic) => {
  const [client, setClient] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [messages, setMessages] = useState([]);
  const [lastMessage, setLastMessage] = useState(null);

  const isTerminal = Const.isTerminal();

  // Funkce pro publikování zpráv
  const publish = useCallback(
    (pubTopic, message) => {
      if (client && isConnected) {
        client.publish(pubTopic, message);
        console.log(`Publikována zpráva na téma ${pubTopic}: ${message}`);
      } else {
        console.warn("Nelze publikovat zprávu: Klient není připojen.");
      }
    },
    [client, isConnected]
  );

  useEffect(() => {
    if (!isTerminal) {
      console.log("Context není terminál");
      return;
    }

    if (!url || !topic) {
      console.error("URL a Téma musí být definovány pro useMqttClient.");
      return;
    }

    // Vytvoření MQTT klienta
    const MqttService = mqtt.connect(url);
    setClient(MqttService);

    // --- Nastavení Event Handlerů ---

    MqttService.on("connect", function () {
      setIsConnected(true);
      console.log("MQTT Klient připojen.");

      // Pokus o odběr až po úspěšném připojení
      MqttService.subscribe(topic, function (err) {
        if (err) {
          console.error(`Chyba při odběru na téma ${topic}:`, err);
        } else {
          console.log(`Odběr na téma ${topic} zahájen.`);
        }
      });
    });

    MqttService.on("error", function (error) {
      console.error("Chyba MQTT:", error);
      setIsConnected(false); // Možné odpojení
    });

    MqttService.on("close", function () {
      setIsConnected(false);
      console.log("Spojení uzavřeno.");
    });

    MqttService.on("message", function (recTopic, message) {
      const msgStr = message.toString();

      const newMessage = { topic: recTopic, payload: msgStr, timestamp: Date.now() };
      setLastMessage(newMessage);
      // Ukládání všech přijatých zpráv do stavu
      setMessages((prevMessages) => [...prevMessages, newMessage]);

      //   if (onNewMessageCallback) {
      //     // onNewMessageCallback(newMessage);
      //   }

      console.log(`[Zpráva] Téma: ${recTopic}, Payload: ${msgStr}`);
    });

    // --- Cleanup Funkce ---
    return () => {
      if (MqttService) {
        MqttService.end(true, () => {
          // Zavřít spojení
          console.log("MQTT klient odpojen a uvolněn.");
        });
      }
    };
  }, [url, topic]); // Závisí na URL a Téma pro možnost dynamické změny

  return { isConnected, messages, publish, lastMessage };
};

export default useMqttClient;
